import styled from "styled-components";
import { ModalTitle } from "../../shared/styles";

export const Container = styled.div`
  font-size: 13px;
  color: #808080;
  padding: 25px 0;
  border-bottom: 1px solid #AFAFAF;
`;

export const RadioContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const CustomModalTitle = styled(ModalTitle)`
  margin-bottom: 0;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  margin: 0 0 0 15px;
  font-weight: 600;
  cursor: pointer;
`;

export const StyledRadio = styled.input.attrs({
  type: "radio"
})`
  margin-right: 6px;
  cursor: pointer;
`;

export const CheckBoxLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledCheckbox = styled.input.attrs({
  type: "checkbox"
})`
  width: 16px;
  height: 16px;
  margin-right: 6px;
  cursor: pointer;
`;

export const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0;
`;

export const SelectorsContainer = styled.div`
  display: flex;
`;
